var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const fetchAndRenderInventory = (block, variantId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!variantId)
        return;
    try {
        block.querySelector('span').innerHTML = '';
        // Testing Only
        // block.querySelector('[data-feature-testing]').innerHTML = '';
        const res = yield fetch(`https://th-admin-api.netlify.app/.netlify/functions/inventory?variant_id=${variantId}`);
        if (!res.ok)
            throw new Error('API error');
        const data = yield res.json();
        // Get shipping messages from global window object
        const shippingMessages = window.threadheadsShippingMessages || {
            fromCountryWarehouse: 'Ships from our {{ country }} Warehouse for faster delivery',
            internationalWarehouse: 'Ships from our International Warehouse',
        };
        // User's current location (Market)
        const currentMarketCode = (block.getAttribute('data-current-market') || '').trim().toUpperCase();
        // Locations (from API)
        const rawLocations = Array.isArray(data.levels) ? data.levels : [];
        // Locations w. uppercase country codes
        const fulfullmentLocations = rawLocations.map((location) => (Object.assign(Object.assign({}, location), { country_code: (location.country_code || '').toUpperCase() })));
        const locationsInCurrentMarket = fulfullmentLocations.filter((location) => location.country_code === currentMarketCode);
        // Inventory NOT TRACKED if *all* locations have available === null
        const variantInventoryNotTracked = fulfullmentLocations.length > 0 && fulfullmentLocations.every((location) => location.available === null);
        let shippingMessage = '';
        if (currentMarketCode) {
            if (variantInventoryNotTracked) {
                // All null == item invetory is not tracked. In that case, search the locations for one in the same market
                shippingMessage =
                    locationsInCurrentMarket.length > 0
                        ? shippingMessages.fromCountryWarehouse.replace('{{ country }}', currentMarketCode)
                        : shippingMessages.internationalWarehouse;
                // If the current market is US, and there is only ONE fulfillment location,
                // and that location is NOT in the US, then do not show any shipping message.
                // if (
                //   currentMarketCode === 'US' &&
                //   fulfullmentLocations.length === 1 &&
                //   fulfullmentLocations[0].country_code !== 'US'
                // ) {
                //   shippingMessage = '';
                // }
                // If the current market is US, and there is only ONE fulfillment location,
                // and that location is in AU, then do not show any shipping message.
                if (currentMarketCode === 'US' &&
                    fulfullmentLocations.length === 1 &&
                    fulfullmentLocations[0].country_code === 'AU') {
                    shippingMessage = '';
                }
            }
            else {
                console.log('inventory tracked');
                const locationsInCurrentMarketWithStock = locationsInCurrentMarket.some((location) => typeof location.available === 'number' && location.available > 0);
                if (locationsInCurrentMarketWithStock) {
                    shippingMessage = shippingMessages.fromCountryWarehouse.replace('{{ country }}', currentMarketCode);
                }
                else {
                    // Show International only if another market actually has stock
                    const otherMarketsWithStock = fulfullmentLocations.filter((loc) => loc.country_code !== currentMarketCode && typeof loc.available === 'number' && loc.available > 0);
                    if (otherMarketsWithStock.length > 0) {
                        // If current market is US and the ONLY other stocked market is AU,
                        // do not show an international shipping message.
                        if (currentMarketCode === 'US' &&
                            otherMarketsWithStock.length === 1 &&
                            otherMarketsWithStock[0].country_code === 'AU') {
                            shippingMessage = '';
                        }
                        else {
                            shippingMessage = shippingMessages.internationalWarehouse;
                        }
                    }
                }
            }
        }
        const html = shippingMessage ? shippingMessage : '';
        block.querySelector('span').innerHTML = html;
    }
    catch (err) {
        console.error(err);
    }
});
const updateLocalisedShipping = (variantId) => __awaiter(void 0, void 0, void 0, function* () {
    const blocks = document.querySelectorAll('[data-localised-shipping]');
    blocks.forEach((block) => {
        const idToUse = variantId || block.getAttribute('data-variant-id') || '';
        if (idToUse) {
            fetchAndRenderInventory(block, idToUse);
        }
    });
});
const localisedShipping = () => {
    updateLocalisedShipping();
    document.addEventListener('variant:change', (event) => {
        var _a, _b;
        const variantID = (_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.variant) === null || _b === void 0 ? void 0 : _b.id;
        if (!variantID)
            return;
        updateLocalisedShipping(variantID);
    });
};
export { localisedShipping };
